import React, { useState, useEffect, useRef } from "react";
import Footer from "components/Footers/Footer.js";
import IndexNavbar from "components/Navbars/IndexNavbar";
import background from "assets/img/background.png";
import background1 from "assets/img/background1.png";
import background2 from "assets/img/background2.png";
import background3 from "assets/img/background3.png";
import almonds from "assets/img/almonds.png";
import dates from "assets/img/dates.png";
import plum from "assets/img/plum.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import home1 from "assets/img/home1.png";
import home2 from "assets/img/home2.png";
import home3 from "assets/img/home3.png";
import home4 from "assets/img/home4.png";
import background4 from "assets/img/background4.png";
import theme1 from "assets/img/theme1.webp";
import theme2 from "assets/img/theme2.webp";
import apple from "assets/img/apple.webp";
import watermelon from "assets/img/watermelon.webp";
import honey from "assets/img/honey.png";
import pancakes from "assets/img/pancakes.png";
import mask from "assets/img/mask.png";
import mask1 from "assets/img/mask1.png";
import milk from "assets/img/milk.png";
import bike from "assets/img/bike.png";
import tin from "assets/img/tin.png";
import peach from "assets/img/peach.png";
import imgbox1 from "assets/img/img-box-1.png";
import imgbox2 from "assets/img/img-box-2.png";
import imgbox3 from "assets/img/img-box-3.png";
import imgbox4 from "assets/img/img-box-4.png";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { Navigation } from "swiper/modules";
import post1 from "assets/img/post1.jpg";
import post2 from "assets/img/post2.jpg";
import post3 from "assets/img/post3.jpg";
import post4 from "assets/img/post4.jpg";
import post5 from "assets/img/post5.jpg";
import waterplants from "assets/img/waterplants.png";
import instagram from "assets/img/instagram.webp";
import Slider from "react-slick";
import Slider1 from "./Slider1";
import Slider2 from "./Slider2";

import snackfood from "assets/img/snackfood.jfif";
import nuts from "assets/img/nuts.jfif";
import spices from "assets/img/spices.jfif";
import vegetables from "assets/img/vegetables.jfif";
import bakery from "assets/img/bakery.jfif";
import frozen from "assets/img/frozen.jfif";
import nonfood from "assets/img/nonfood.jfif";
import principals from "assets/img/Principals.png";
import applications from "assets/img/Applications.png";
import india from "assets/img/india.png";
import one from "assets/img/one.png";
import two from "assets/img/two.png";
import turnkey from "assets/img/turnkey.png";
import manufacturing from "assets/img/manufacturing.png";
import icon1 from "assets/img/icon1.png";
import icon2 from "assets/img/icon2.png";
import icon3 from "assets/img/icon3.png";
import water12 from "assets/img/water12.png";
import tank1 from "assets/img/tank1.png";
import tank2 from "assets/img/tank2.png";
import tank3 from "assets/img/tank3.png";
import tank4 from "assets/img/tank4.png";
import tank5 from "assets/img/tank5.png";
import applicationss from "assets/img/Applicationss.jpeg";
import bgimg from "assets/img/bgimg.png";
import chooseus from "assets/img/chooseus.png";
import water13 from "assets/img/water13.png";
import imgtwo from "assets/img/imgtwo.png";
import imgthree from "assets/img/imgthree.png";
import imgfour from "assets/img/imgfour.png";
import imgfive from "assets/img/imgfive.png";
import imgsix from "assets/img/imgsix.png";
import imgseven from "assets/img/imgseven.jpg";
import imgeight from "assets/img/imgeight.jpg";
import imgnine from "assets/img/imgnine.jpg";
import dairyplant from "assets/img/dairyplant.jpg";
import cheeseplant from "assets/img/cheeseplant.jpg";
import waterplant from "assets/img/waterplant.jpg";
import spicesplant from "assets/img/spicesplant.webp";
import ipt1 from "assets/img/ipt1.png";
import ipt2 from "assets/img/ipt2.png";
import ipt3 from "assets/img/ipt3.png";
import bg1 from "assets/img/bg1.jpg";
import bgg2 from "assets/img/bgg2.jpg";
import { Link } from "react-router-dom";
import babyfood from "assets/img/babyfood.png";
import cream from "assets/img/cream.png";
import desserts from "assets/img/Desserts.png";
import fruitpreparations from "assets/img/FruitPreparations.png";
import guacamole from "assets/img/Guacamole.png";
import ketchup from "assets/img/Ketchup.png";

export default function Homepage1() {
  const [isHovered, setIsHovered] = useState(false);

  const [activeTab, setActiveTab] = useState("All Products");
  const tabs = [
    "All Products",
    "Snack Food",
    "Dried Fruits & Nuts",
    "Spices & Powders",
    "Fruits & Vegetables",
    "Bakery",
    "Frozen Foods",
    "Non-Food",
  ];

  const buttonRef = useRef(null);
  const textRef = useRef(null);

  return (
    <section className="poppins">
      <IndexNavbar />
      <section className="headerbg1 xl:pt-8 xl:pb-20 lg:pt-8 lg:pb-20 md:pt-32 md:pb-8 xl:px-0 lg:px-4 px-4 xl:block lg:block md:block sm:hidden hidden">
        <Swiper
          slidesPerView={1}
          spaceBetween={0}
          centeredSlides={false}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          breakpoints={{
            1280: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 },
            1024: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 25 },
            768: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 20 },
            400: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 15 },
            360: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 },
          }}
          modules={[Autoplay, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="bg-gradient xl:h-475 lg:h-450 md:h-400  rounded-xll  container mx-auto xl:w-11/12 lg:w-12/12  md:w-12/12">
              <div className=" xl:pt-32 lg:pt-32 md:pt-16 poppins ">
                <div className="xl:pl-8 xl:w-6/12  lg:pl-4 lg:w-8/12 md:w-8/12 md:pl-8">
                  <h1 className="xl:text-5xl lg:text-4xl md:text-3xl font-semibold text-blackk fade-item-1">
                    Revolutionizing<br/> Food Processing
                  </h1>
                  <p className="xl:pt-4 lg:pt-4 pt-2 md:text-base text-para xl:text-lg lg:text-base fade-item-2">
                    " We integrate cutting-edge automation and AI-driven
                    solutions to enhance efficiency, precision, and scalability
                    in food production."
                  </p>
                  <a href="/contact">
                    <button className="z-50 blue rounded-md xl:px-8 xl:py-3 lg:px-4 lg:py-2 xl:mt-6 lg:mt-4  text-white  fade-item-3 md:px-4 py-2 mt-2">
                      Learn More
                    </button>
                  </a>
                </div>
              </div>

              <div className="flex justify-end">
                <div className="flex justify-end">
                  <img
                    className="xl:w-12/12 lg:w-8/12 md:w-6/12 md:-mt-0 lg:-mt-12 xl:-mt-64 fade-container"
                    src={water13}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="bg-gradient xl:h-475 lg:h-450 md:h-400 md:w-12/12  rounded-xll  container mx-auto xl:w-11/12 lg:w-12/12 ">
              <div className=" xl:pt-32 lg:pt-32 md:pt-16 poppins ">
                <div className="xl:pl-8 xl:w-6/12 lg:pl-4 lg:w-8/12 md:w-8/12 md:pl-8">
                  <h1 className="xl:text-5xl lg:text-4xl md:text-3xl font-semibold text-blackk fade-item-1">
                    Sustainable and<br/> Smart Technologies
                  </h1>
                  <p className="xl:pt-4 lg:pt-4 pt-2 md:text-base text-para xl:text-lg lg:text-base fade-item-2">
                    "Our eco-friendly processing solutions optimize resource
                    usage, reduce waste, and promote sustainability in the
                    evolving food industry."
                  </p>
                  <a href="/contact">
                    <button className="z-50 blue rounded-md xl:px-8 xl:py-3 lg:px-4 lg:py-2 xl:mt-6 lg:mt-4  text-white  fade-item-3 md:px-4 py-2 mt-2">
                      Learn More
                    </button>
                  </a>
                </div>
              </div>

              <div className="">
                <div className="flex justify-end">
                  <img
                    className="xl:w-6/12 lg:w-6/12 md:w-6/12 md:-mt-8 lg:-mt-12 xl:-mt-64 fade-container"
                    src={dates}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="bg-gradient xl:h-475 lg:h-450 md:h-400 md:w-12/12  rounded-xll  container mx-auto xl:w-11/12 lg:w-12/12">
              <div className=" xl:pt-32 lg:pt-32 md:pt-16 poppins ">
                <div className="xl:pl-8 xl:w-6/12 lg:pl-4 lg:w-8/12 md:w-8/12 md:pl-8">
                  <h1 className="xl:text-5xl lg:text-4xl md:text-3xl font-semibold text-blackk fade-item-1">
                    Enhancing <br/>Quality and Safety
                  </h1>
                  <p className="xl:pt-4 lg:pt-4 pt-2 md:text-base text-para xl:text-lg lg:text-base fade-item-2">
                    "Advanced sterilization, preservation, and packaging
                    techniques ensure the highest standards of food safety,
                    freshness, and shelf stability."
                  </p>
                  <a href="/contact">
                    <button className="z-50 blue rounded-md xl:px-8 xl:py-3 lg:px-4 lg:py-2 xl:mt-6 lg:mt-4  text-white  fade-item-3 md:px-4 py-2 mt-2">
                      Learn More
                    </button>
                  </a>
                </div>
              </div>

              <div className="">
                <div className="flex justify-end">
                  <img
                    className="xl:w-6/12 xl:-mt-64 lg:w-6/12 md:w-6/12 md:-mt-8 lg:-mt-12 fade-container"
                    src={plum}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div className="xl:block lg:hidden md:hidden sm:block block">
          <div className="arrows flex justify-center">
            <button className="custom-prev bgarrows text-blue rounded-md p-2 shadow-md">
              ❮
            </button>
            <button className="custom-next bgarrows text-blue rounded-md p-2 shadow-md xl:mr-0 lg:mr-8 ">
              ❯
            </button>
          </div>
        </div>
      </section>

      {/* mobile view */}
      <section className="xl:hidden lg:hidden md:hidden sm:block block headerbg1 pt-32 px-4 pb-16">
        <Swiper
          slidesPerView={1}
          spaceBetween={0}
          centeredSlides={false}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          breakpoints={{
            400: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 15 },
            360: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 },
          }}
          modules={[Autoplay, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="h-500-px  bg-gradient rounded-xll  container mx-auto">
              <div className=" poppins ">
                <div className="pl-4 ">
                  <h1 className="text-3xl font-semibold text-blackk fade-item-1 pt-12">
                    Revolutionizing Food Processing
                  </h1>
                  <p className=" pt-2 text-base text-para  fade-item-2">
                    " We integrate cutting-edge automation and AI-driven
                    solutions to enhance efficiency, precision, and scalability
                    in food production."
                  </p>
                  <a href="/contact">
                    <button className="blue rounded-md   text-white  fade-item-3 px-4 py-2 mt-2 z-50">
                      Learn More
                    </button>
                  </a>
                </div>
                <div className="flex justify-end">
                  <img className="w-10/12  fade-container" src={water12} alt="" />
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="h-500-px  bg-gradient rounded-xll  container mx-auto">
              <div className=" poppins ">
                <div className="pl-4 ">
                  <h1 className="text-3xl font-semibold text-blackk fade-item-1 pt-12">
                    Sustainable and Smart Technologies
                  </h1>
                  <p className=" pt-2 text-base text-para  fade-item-2">
                    "Our eco-friendly processing solutions optimize resource
                    usage, reduce waste, and promote sustainability in the
                    evolving food industry."
                  </p>
                  <a href="/contact">
                    <button className="blue rounded-md   text-white  fade-item-3 px-4 py-2 mt-2 z-50">
                      Learn More
                    </button>
                  </a>
                </div>
                <div className="flex justify-end">
                  <img
                    className="w-12/12 pt-12  fade-container"
                    src={dates}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="h-500-px  bg-gradient rounded-xll  container mx-auto">
              <div className=" poppins ">
                <div className="pl-4 ">
                  <h1 className="text-3xl font-semibold text-blackk fade-item-1 pt-12">
                    Enhancing Quality and Safety
                  </h1>
                  <p className=" pt-2 text-base text-para  fade-item-2">
                    "Advanced sterilization, preservation, and packaging
                    techniques ensure the highest standards of food safety,
                    freshness, and shelf stability.."
                  </p>
                  <a href="/contact">
                    <button className="blue rounded-md   text-white  fade-item-3 px-4 py-2 mt-2 z-50">
                      Learn More
                    </button>
                  </a>
                </div>
                <div className="flex justify-end">
                  <img
                    className="w-12/12 pt-20 fade-container"
                    src={almonds}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div className="xl:hidden lg:hidden md:hidden sm:hidden hidden">
          <div className="arrows flex justify-center">
            <button className="custom-prev bgarrows text-orange rounded-md p-2 shadow-md">
              ❮
            </button>
            <button className="custom-next bgarrows text-orange rounded-md p-2 shadow-md mr-12">
              ❯
            </button>
          </div>
        </div>
      </section>

      <section className="headerbg1 xl:px-0 px-4">
        <div className="grid xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 container mx-auto xl:gap-4 gap-4 ">
          <div>
            <div className="bg-white rounded-md xl:p-8 lg:p-8 p-4 justify-center items-center">
              <div className="flex  xl:gap-8 gap-4">
                <div>
                  <img className="w-12" src={tank1} alt="" />
                </div>
                 
                 <div className="xl:block lg:block md:block sm:hidden hidden">
                <h1 className="xl:text-lg lg:text-lg text-base text-para font-semibold xl:pt-0 lg:pt-0 pt-2">
                  Storage<br></br> Tanks
                </h1>
                </div>
                 {/* mobile view */}
                <div className="xl:hidden lg:hidden md:hidden sm:block block">
                <h1 className=" text-xl text-para font-semibold pt-4">
                  Storage Tanks
                </h1>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-md xl:p-8 lg:p-8 p-4 justify-center items-center">
              <div className="flex xl:gap-8 gap-4">
                <div>
                  <img className="w-12" src={tank2} alt="" />
                </div>

                <div className="xl:block lg:block md:block sm:hidden hidden">
                <h1 className="xl:text-lg lg:text-lg text-base text-para font-semibold xl:pt-0 lg:pt-0 pt-2">
                  Process<br></br> Tanks
                </h1>
                </div>
                 {/* mobile view */}
                <div className="xl:hidden lg:hidden md:hidden sm:block block">
                <h1 className=" text-xl text-para font-semibold pt-4">
                  Process Tanks
                </h1>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-md xl:p-8 lg:p-8 p-4 justify-center items-center">
              <div className="flex xl:gap-8 gap-4">
                <div>
                  <img className="w-12" src={tank3} alt="" />
                </div>

                <div className="xl:block lg:block md:block sm:hidden hidden">
                <h1 className="xl:text-lg lg:text-lg text-base text-para font-semibold xl:pt-0 lg:pt-0 pt-2">
                  Mixing<br></br> Tanks
                </h1>
                </div>
                 {/* mobile view */}
                <div className="xl:hidden lg:hidden md:hidden sm:block block">
                <h1 className=" text-xl text-para font-semibold pt-4">
                  Mixing Tanks
                </h1>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-md xl:p-8 lg:p-8 p-4 justify-center items-center">
              <div className="flex xl:gap-8 gap-4">
                <div>
                  <img className="w-12" src={tank4} alt="" />
                </div>

                <div className="xl:block lg:block md:block sm:hidden hidden">
                <h1 className="xl:text-lg lg:text-lg text-base text-para font-semibold xl:pt-0 lg:pt-0 pt-2">
                  CIP<br></br> Tanks
                </h1>
                </div>
                 {/* mobile view */}
                <div className="xl:hidden lg:hidden md:hidden sm:block block">
                <h1 className=" text-xl text-para font-semibold pt-4">
                  CIP Tanks
                </h1>
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <div className="bg-white rounded-md xl:p-8 lg:p-8 p-4 justify-center items-center">
              <div className="flex xl:gap-4 gap-4">
                <div>
                  <img className="xl:w-12 lg:w-12 md:w-12 w-12" src={tank5} alt="" />
                </div>

                <div className="xl:block lg:block md:block sm:hidden hidden">
                <h1 className="xl:text-lg lg:text-lg text-base text-para font-semibold xl:pt-0 lg:pt-0 pt-2">
                  Incubation<br></br> Tanks
                </h1>
                </div>
                 {/* mobile view */}
                <div className="xl:hidden lg:hidden md:hidden sm:block block">
                <h1 className=" text-xl text-para font-semibold pt-4">
                  Incubation Tanks
                </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        
        {/* <div className="xl:hidden lg:hidden md:hidden sm:block block  mt-4">
            <div className="bg-white rounded-md  p-8 justify-center items-center ">
              <div className="flex xl:gap-4 gap-4">
                <div>
                  <img className=" w-12" src={tank5} alt="" />
                </div>

                <h1 className=" text-xl pt-4 text-para font-semibold">
                  Incubation Tanks
                </h1>
              </div>
            </div>
          </div> */}
      </section>

      <section className="headerbg1 xl:pt-8 lg:pt-8 md:pt-0 ">
        <div className="container mx-auto ">
          <div className="">
            <div
              className="relative   px-4 xl:px-24 lg:px-16 lg:py-16 xl:py-16 md:py-16 py-16"
              style={{
                backgroundImage: `url(${bgimg})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "782px 0px",
              }}
            >
              <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 bg-white  shadow-lg">
                <div className="xl:w-10/12 lg:w-10/12 md:w-10/12 flex justify-center items-center">
                  <img
                    className="xl:w-12/12 lg:w-12/12 md:w-12/12"
                    src={applicationss}
                    alt="Healthy Food"
                  />
                </div>
                <div className=" flex items-center xl:mr-8 lg:mr-8 mr-4 xl:py-0 lg:py-0 md:py-0 py-8 xl:pl-0 lg:pl-0 md:pl-0 pl-4">
                  <div>
                    <p className="text-blue xl:text-xl text-xl font-semibold uppercase">
                      our stories
                    </p>
                    <h2 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl md:pt-1 pt-4 lg:pt-4 text-blackk font-bold xl:pt-4">
                      Innovative Food Manufacturing
                    </h2>
                    <p className="text-para xl:text-base text-base lg:pt-4 xl:pt-4 md:pt-1 pt-4">
                      We leverage state-of-the-art automation, precision
                      engineering, and AI-driven processes to enhance food
                      quality, safety, and efficiency. Our innovative solutions
                      redefine food manufacturing, ensuring sustainability and
                      excellence in every step of the production process.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="headerbg1 xl:pt-4  xl:px-0 px-4">
        <p className="text-blue xl:text-xl font-semibold uppercase text-center">
          our services
        </p>
        <h2 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-bold text-black pt-4 text-center">
          Delivering Excellence <br /> Through Our Specialized Services
        </h2>
        <div className="container mx-auto grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 lg:gap-4 gap-4 xl:mt-16 lg:mt-16 md:mt-12 mt-8">
          <div>
            <div
              className="xl:h-450 lg:h-450 md:h-400 h-500-px rounded-xl "
              style={{
                backgroundImage: `url(${dairyplant})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="xl:p-8 lg:p-4 p-4 overlay rounded-xl">
                <div className="flex flex-col justify-between h-full">
                  {/* Image at the top */}

                  <div className="">
                    <h1 className="xl:text-9xl lg:text-5xl md:text-5xl text-5xl font-bold  text-grey uppercase">
                      01
                    </h1>
                  </div>
                  {/* Text in the middle */}
                  <div className="flex justify-between items-center xl:pt-64 lg:pt-48 md:pt-32 pt-48">
                    <p className="xl:text-xl lg:text-base md:text-xl text-lg text-white font-semibold text-center">
                      Dairy Plant
                    </p>

                    {/* Clickable Arrow Link */}
                    <a
                      href="/service"
                      className="h-10 w-10 rounded-full flex items-center justify-center  borderwhite "
                    >
                      <p
                        className="xl:text-xl text-white"
                        style={{ zIndex: 50 }}
                      >
                        ➜
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div
              className="xl:h-450 lg:h-450 md:h-400 h-500-px rounded-xl "
              style={{
                backgroundImage: `url(${cheeseplant})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div
                className="xl:p-8 lg:p-4 p-4 overlay rounded-xl"
                style={{ position: "relative", zIndex: 1 }}
              >
                <div className="flex flex-col justify-between h-full">
                  {/* Image at the top */}

                  <div className="">
                    <h1 className="xl:text-9xl lg:text-5xl md:text-5xl text-5xl font-bold  text-grey uppercase">
                      02
                    </h1>
                  </div>
                  {/* Text in the middle */}
                  <div className="flex justify-between items-center xl:pt-64 lg:pt-48 md:pt-32 pt-48">
                    <p className="xl:text-xl lg:text-base md:text-xl text-lg text-white font-semibold text-center  ">
                      Cheese Plants
                    </p>

                    <div>
                      <div className="h-10 w-10 rounded-full flex justify-center borderwhite">
                        <a href="/service">
                          <p className="xl:text-xl text-white pt-1">➜</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div
              className="xl:h-450 lg:h-450 md:h-400 h-500-px rounded-xl "
              style={{
                backgroundImage: `url(${waterplant})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div
                className="xl:p-8 lg:p-4 p-4 overlay rounded-xl"
                style={{ position: "relative", zIndex: 1 }}
              >
                <div className="flex flex-col justify-between h-full">
                  {/* Image at the top */}

                  <div className="">
                    <h1 className="xl:text-9xl lg:text-5xl md:text-5xl text-5xl font-bold  text-grey uppercase">
                      03
                    </h1>
                  </div>
                  {/* Text in the middle */}
                  <div className="flex justify-between items-center xl:pt-64 lg:pt-48 md:pt-32 pt-48">
                    <p className="xl:text-xl lg:text-base md:text-xl text-lg text-white font-semibold text-center  ">
                      Water Plants
                    </p>

                    <div>
                      <div className="h-10 w-10 rounded-full flex justify-center borderwhite">
                        <a href="/service">
                          <p className="xl:text-xl text-white pt-1">➜</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div
              className="xl:h-450 lg:h-450 md:h-400 h-500-px rounded-xl "
              style={{
                backgroundImage: `url(${spicesplant})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div
                className="xl:p-8 lg:p-4 p-4 overlay rounded-xl"
                style={{ position: "relative", zIndex: 1 }}
              >
                <div className="flex flex-col justify-between h-full">
                  {/* Image at the top */}

                  <div className="">
                    <h1 className="xl:text-9xl lg:text-5xl md:text-5xl text-5xl font-bold  text-grey uppercase">
                      04
                    </h1>
                  </div>
                  {/* Text in the middle */}
                  <div className="flex justify-between items-center xl:pt-64 lg:pt-48 md:pt-32 pt-48">
                    <p className="xl:text-xl lg:text-base md:text-xl text-lg text-white font-semibold text-center  ">
                      Spices
                    </p>

                    <div>
                      <div className="h-10 w-10 rounded-full flex justify-center borderwhite">
                        <a href="/service">
                          <p className="xl:text-xl text-white pt-1">➜</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="headerbg1  xl:pb-20  lg:pb-16  pb-12">
        <div className="container mx-auto grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 xl:gap-6 lg:gap-4 gap-4 xl:px-0 px-4">
          <div>
            <div
              className="xl:h-600 lg:h-450 md:h-400 h-500-px rounded-xl animated-bg"
              style={{
                backgroundImage: `url(${principals})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div
                className="xl:py-8 lg:py-4 py-4 overlay"
                style={{ position: "relative", zIndex: 1 }}
              >
                <div className="flex flex-col justify-between h-full">
                 

                  <div className="flex justify-center">
                    <h1 className="xl:text-5xl font-bold text-center text-white uppercase">
                      Principals
                    </h1>
                  </div>
                  
                  <div className="flex justify-center items-center flex-grow">
                    <p className="xl:text-xl lg:text-base md:text-base text-lg text-white font-semibold text-center xl:pt-64 lg:pt-48 md:pt-32 pt-48 xl:px-4">
                      With strong project engineering knowledge and access to
                      the latest global technology from across the world, we
                      provide simplified solutions to our customers’ various
                      business needs
                    </p>
                  </div>

                 
                  <div className="flex justify-center mb-8">
                    <button
                      className=" borderyellow xl:px-8 xl:py-2 lg:px-4 lg:py-2 px-4 py-2 mt-4 text-white xl:text-lg  xl:mt-6 box1"
                      style={{ position: "relative", zIndex: 2 }}
                    >
                      Learn More ›
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div
              className="xl:h-600 lg:h-450 md:h-400 h-500-px rounded-xl animated-bg"
              style={{
                backgroundImage: `url(${applications})`, 
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="xl:py-8 lg:py-4 py-4 overlay">
                <div className="flex flex-col justify-between h-full">
                  
                  <div className="flex justify-center">
                    <h1 className="xl:text-5xl font-bold text-center text-white uppercase">
                      applications
                    </h1>
                  </div>

                  
                  <div className="flex justify-center items-center flex-grow">
                    <p className="xl:text-xl lg:text-base md:text-base text-lg text-white font-semibold text-center xl:pt-64 lg:pt-52 md:pt-36 pt-48 xl:px-4">
                      Our state-of-the-art engineering capabilities provide
                      solutions to a variety of applications required in the
                      food processing industry such as mixing, conveying,
                      sorting and packaging.
                    </p>
                  </div>

                  
                  <div className="flex justify-center mb-8">
                    <button className="borderyellow xl:px-8 xl:py-2 lg:px-4 lg:py-2 px-4 py-2 mt-4 text-white xl:text-lg  xl:mt-6 box1">
                      Learn More ›
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div
              className="xl:h-600 lg:h-450 md:h-400 h-500-px rounded-xl animated-bg"
              style={{
                backgroundImage: `url(${india})`, 
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="xl:py-8 lg:py-4 py-4 overlay">
                <div className="flex flex-col justify-between h-full">
                  
                  <div className="flex justify-center">
                    <h1 className="xl:text-5xl font-bold text-center text-white uppercase">
                      Our Presence
                    </h1>
                  </div>

                  
                  <div className="flex justify-center items-center flex-grow">
                    <p className="xl:text-xl lg:text-base md:text-base text-lg text-white font-semibold text-center xl:pt-44 lg:pt-52 md:pt-36 pt-48 xl:px-4">
                      Over the past decade, Kiron Food Processing Technologies
                      (KFPT) has played a vital role in finding innovative
                      solutions by representation and connecting the best food
                      processing systems manufacturers from around the world to
                      India's flourishing processed food industry
                    </p>
                  </div>

                  
                  <div className="flex justify-center mb-8">
                    <button className="borderyellow xl:px-8 xl:py-2 lg:px-4 lg:py-2 px-4 py-2 mt-4 text-white xl:text-lg  xl:mt-6 box1">
                      Learn More ›
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section
        className="xl:pt-16 xl:pb-16 lg:pt-16 lg:pb-16 md:pt-16 md:pb-16 pt-12 pb-12"
        style={{
          backgroundImage: `url(${bg1})`,
          width: "100%",

          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container mx-auto xl:px-0 px-4 ">
          <p className="text-blue xl:text-xl font-semibold uppercase text-center">
            WHY CHOOSE US
          </p>
          <h2 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl pt-4 text-blackk font-bold text-center xl:pt-4 lg:pt-4">
            We Are Different<br></br> Than Others
          </h2>

          <div className=" grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 xl:gap-0 lg:gap-4 gap-4 xl:mt-16 lg:mt-16 mt-8">
            <div>
              <div className=" ">
                <div className="">
                  <div className="flex justify-center">
                    <img className="w-16 " src={babyfood} alt="" />
                  </div>
                </div>

                <div>
                  <h1 className="text-center xl:text-2xl lg:text-xl text-xl text-blackk font-bold xl:pt-4 pt-4">
                    Baby Food
                  </h1>
                  <div className="xl:block lg:block md:hidden sm:hidden hidden">
                    <p className="text-center xl:text-base lg:text-base text-base lg:pt-2 text-para xl:pt-2 pt-2">
                      Nutrient-rich, safe, and easily digestible<br></br> with
                      advanced processing.
                    </p>
                  </div>
                  <div className="xl:hidden lg:hidden md:block sm:block block">
                    <p className="text-center  text-base  text-para  pt-2 md:px-0 px-8">
                      Nutrient-rich, safe, and easily digestible with advanced
                      processing.
                    </p>
                  </div>
                </div>
              </div>

              <div className="lg:mt-8 xl:mt-8 md:mt-8 mt-8">
                <div className="">
                  <div className="flex justify-center">
                    <img className="w-16 " src={cream} alt="" />
                  </div>
                </div>

                <div>
                  <h1 className="xl:text-2xl lg:text-xl text-xl text-center text-blackk font-bold xl:pt-4 pt-4">
                    Creams
                  </h1>
                  <div className="xl:block lg:block md:hidden sm:hidden hidden">
                    <p className="text-center xl:text-base lg:text-base text-base lg:pt-2 text-para xl:pt-2 pt-2">
                      Smooth texture and perfect consistency<br></br> with
                      high-tech processing.
                    </p>
                  </div>
                  <div className="xl:hidden lg:hidden md:block sm:block block">
                    <p className="text-center  text-base  text-para  pt-2 md:px-0 px-8">
                      Smooth texture and perfect consistency with high-tech
                      processing.
                    </p>
                  </div>
                </div>
              </div>

              <div className=" lg:mt-8 xl:mt-8 md:mt-8 mt-8">
                <div className="">
                  <div className="flex justify-center">
                    <img className="w-16 " src={desserts} alt="" />
                  </div>
                </div>

                <div>
                  <h1 className="text-center xl:text-2xl lg:text-xl text-xl text-blackk font-bold xl:pt-4 pt-4">
                    Desserts
                  </h1>
                  <div className="xl:block lg:block md:hidden sm:hidden hidden">
                    <p className="text-center xl:text-base lg:text-base text-base lg:pt-2 text-para xl:pt-2 pt-2">
                      Balanced flavor, texture, and stability<br></br> with
                      precision cooling.
                    </p>
                  </div>
                  <div className="xl:hidden lg:hidden md:block sm:block block">
                    <p className="text-center  text-base  text-para  pt-2 md:px-0 px-8">
                      Balanced flavor, texture, and stability with precision
                      cooling.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center relative ">
              <div className="relative flex justify-center">
                <img
                  className="xl:w-12/12 lg:w-8/12 md:w-12/12 w-full"
                  src={chooseus}
                  alt=""
                />
              </div>
            </div>

            <div>
              <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-6 ">
                <div className="">
                  <div className="flex justify-center">
                    <img className="w-16 " src={fruitpreparations} alt="" />
                  </div>
                </div>

                <div>
                  <h1 className="xl:text-2xl text-center lg:text-xl text-xl text-blackk font-bold xl:pt-4 lg:pt-4 md:pt-4 pt-4">
                    Fruit Preparations
                  </h1>
                  <div className="xl:block lg:block md:hidden sm:hidden hidden">
                    <p className="text-center xl:text-base lg:text-base text-base lg:pt-2 text-para xl:pt-2 pt-2">
                      Retains natural taste, color, and nutrients<br></br> with
                      innovative processing.
                    </p>
                  </div>
                  <div className="xl:hidden lg:hidden md:block sm:block block">
                    <p className="text-center  text-base  text-para  pt-2 md:px-0 px-8">
                      Retains natural taste, color, and nutrients with
                      innovative processing.
                    </p>
                  </div>
                </div>
              </div>

              <div className=" lg:mt-8 xl:mt-8 md:mt-8 mt-8">
                <div className="">
                  <div className="flex justify-center">
                    <img className="w-16 " src={guacamole} alt="" />
                  </div>
                </div>

                <div>
                  <h1 className="xl:text-2xl text-center lg:text-xl text-xl text-blackk font-bold xl:pt-4 pt-4">
                    Guacamole
                  </h1>
                  <div className="xl:block lg:block md:hidden sm:hidden hidden">
                    <p className="text-center xl:text-base lg:text-base text-base lg:pt-2 text-para xl:pt-2 pt-2">
                      Freshness and vibrant color preserved<br></br> with cold
                      processing.
                    </p>
                  </div>
                  <div className="xl:hidden lg:hidden md:block sm:block block">
                    <p className="text-center  text-base  text-para  pt-2 md:px-0 px-8">
                      Freshness and vibrant color preserved with cold
                      processing.
                    </p>
                  </div>
                </div>
              </div>

              <div className=" lg:mt-8 xl:mt-8 md:mt-8 mt-8">
                <div className="">
                  <div className="flex justify-center">
                    <img className="w-16 " src={ketchup} alt="" />
                  </div>
                </div>

                <div>
                  <h1 className="xl:text-2xl text-center lg:text-xl text-xl text-blackk font-bold xl:pt-4 pt-4">
                    Ketchup
                  </h1>
                  <div className="xl:block lg:block md:hidden sm:hidden hidden">
                    <p className="text-center xl:text-base lg:text-base text-base lg:pt-2 text-para xl:pt-2 pt-2">
                      Rich flavor and smooth texture<br></br> with precision
                      blending.
                    </p>
                  </div>
                  <div className="xl:hidden lg:hidden md:block sm:block block">
                    <p className="text-center  text-base  text-para  pt-2 md:px-0 px-8">
                      Rich flavor and smooth texture with precision blending.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="flex justify-center xl:mt-12 lg:mt-8 md:mt-8 mt-8">
            <button className="borderblue xl:px-8 xl:py-2 lg:px-4 lg:py-2 px-4 py-2 rounded-md text-blue xl:text-lg">
              Learn More
            </button>
          </div> */}
        </div>
      </section>

      <section className="headerbg1 xl:pt-16 xl:pb-16 lg:pt-12 lg:pb-16 md:pt-12 md:pb-16 pt-12 pb-12">
        <div className="container mx-auto xl:px-0 px-4">
          <p className="text-blue xl:text-xl font-semibold uppercase text-center">
            India's
          </p>
          <h2 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl text-blackk font-bold text-center pt-2">
            Flourishing Processed <br></br> Food Industry
          </h2>
          <div className=" grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1  lg:gap-4 gap-4 xl:mt-4 lg:mt-6  md:pt-8 pt-8">
            <div>
              <div
                className="zoom-wrapper xl:h-250 lg:h-250 md:h-240 h-200-px"
                style={{
                  backgroundImage: `url(${principals})`,
                  width: "100%",

                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                  }}
                ></div>
                <div className="stylee ">
                  <p>P</p>
                </div>
              </div>

              <h1 className="xl:text-xl text-blackk text-center xl:pt-8 pt-4">
                Principals
              </h1>
              <p className="xl:text-sm xl:pt-4 pt-2 text-para text-center">
                With strong project engineering knowledge and access to the
                latest global technology from across the world, we provide
                simplified solutions to our customers’ various business needs
              </p>
              <a href="/product">
                <p className="xl:text-sm xl:pt-4 pt-4 text-blue text-center">
                  + Read More
                </p>
              </a>
            </div>

            <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-6">
              <div
                className="zoom-wrapper xl:h-250 lg:h-250 md:h-240 h-200-px"
                style={{
                  backgroundImage: `url(${applications})`,
                  width: "100%",

                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                  }}
                ></div>
                <div className="stylee">
                  <p>A</p>
                </div>
              </div>

              <h1 className="xl:text-xl text-blackk text-center xl:pt-8 pt-4">
                Applications
              </h1>
              <p className="xl:text-sm xl:pt-4 text-para text-center pt-2">
                Our state-of-the-art engineering capabilities provide solutions
                to a variety of applications required in the food processing
                industry such as mixing, conveying, sorting and packaging
              </p>
              <a href="/product">
                <p className="xl:text-sm xl:pt-4 text-blue text-center pt-4">
                  + Read More
                </p>
              </a>
            </div>

            <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-6">
              <div
                className="zoom-wrapper xl:h-250 lg:h-250 md:h-240 h-200-px"
                style={{
                  backgroundImage: `url(${india})`,
                  width: "100%",

                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                  }}
                ></div>
                <div className="stylee">
                  <p>P</p>
                </div>
              </div>

              <h1 className="xl:text-xl text-blackk text-center xl:pt-8 pt-4">
                Our Presence
              </h1>
              <p className="xl:text-sm xl:pt-4 text-para text-center pt-2">
                Over the past decade, has played a vital role in finding
                innovative solutions by representation and connecting the best
                food processing systems manufacturers from around the world
              </p>
              <a href="/product">
                <p className="xl:text-sm xl:pt-4 text-blue text-center pt-4">
                  + Read More
                </p>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </section>
  );
}
